// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3P3zL","consentsList":"PatientConsents_consentsList__2CWaz","consentsListEmpty":"PatientConsents_consentsListEmpty__ZsQXh"};